module.exports = "<div class=\"periodListLink\" ng-click=\"$ctrl.goToPeriodListMobile()\">\n  <p>{{'VACATIONS_ABSENCES.PERIOD_LIST.REQUEST_STATUS' | translate}}</p>\n  <span class=\"icon-arrow-select-up\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/features/myVacationsMobile/periodListLink/periodListLink.html
// module id = 1163
// module chunks = 0